import React, {useMemo, useState} from 'react';
import AuthService from '../Services/AuthService';
import './PreRegistroStep1.css';

const securePasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
const preRegOpenSignInKey = 'pre_registration_open_signin';

const sanitizePasswordValue = (value) => {
  // Keep special characters but block quote characters, backslash and control chars.
  const withoutQuotes = value.replace(/["'\\]/g, '');
  return Array.from(withoutQuotes)
    .filter((ch) => {
      const code = ch.charCodeAt(0);
      return code >= 32 && code !== 127;
    })
    .join('');
};

export default function CandidatePassword() {
  const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const accountParam = queryParams.get('account') || '';
  const validationParam = queryParams.get('validation') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [touched, setTouched] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [recid, setRecid] = useState('');

  const isPasswordSecure = securePasswordRegex.test(password);
  const isPasswordMatch = confirmPassword.length > 0 && password === confirmPassword;

  const handleUpdate = async () => {
    setTouched(true);
    setErrorMessage('');

    if (!isPasswordSecure || !isPasswordMatch) {
      return;
    }

    if (!accountParam || !validationParam) {
      setErrorMessage('El enlace de recuperación no es válido.');
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await AuthService.candidatesPassRecovery(accountParam, password, validationParam);
      const responseData = response && response.data;

      if (responseData && responseData.success === true) {
        setIsSuccess(true);
        setSuccessMessage(responseData.message || 'Tu contraseña fue actualizada correctamente.');
        setRecid(responseData.recid || '');
        setPassword('');
        setConfirmPassword('');
        return;
      }

      setErrorMessage((responseData && responseData.message) || 'No fue posible actualizar la contraseña.');
    } catch (error) {
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setErrorMessage(backendMessage || 'No fue posible actualizar la contraseña.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGoToSignIn = () => {
    if (recid) {
      localStorage.setItem(preRegOpenSignInKey, 'true');
      window.location.href = '/preregistro/?&recid=' + recid;
      return;
    }
    window.location.href = '/preregistro/';
  };

  return (
    <div className="prereg-step1-page">
      <div className="prereg-step1-card">
        <div className="prereg-step1-content prereg-password-content">
          <div className="prereg-password-screen">
            <img className="prereg-password-logo" src="/assets/img/thermomix_header_2023.png" alt="Thermomix" />
            <h3 className="prereg-password-title">Actualizar Contraseña:</h3>

            {isSuccess ? (
              <p className="prereg-account-lookup-success">{successMessage}</p>
            ) : (
              <>
                <input
                  type="password"
                  className="prereg-input prereg-password-input"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(sanitizePasswordValue(e.target.value))}
                />

                <input
                  type="password"
                  className="prereg-input prereg-password-input"
                  placeholder="Confirmar contraseña"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(sanitizePasswordValue(e.target.value))}
                />

                {touched && !isPasswordSecure ? (
                  <div className="prereg-curp-error">La contraseña debe tener al menos 8 caracteres, mayúscula, minúscula, número y símbolo.</div>
                ) : null}
                {touched && isPasswordSecure && !isPasswordMatch ? (
                  <div className="prereg-curp-error">Las contraseñas no coinciden.</div>
                ) : null}
                {errorMessage ? (
                  <div className="prereg-curp-error">{errorMessage}</div>
                ) : null}
              </>
            )}

            <div className="prereg-submit-holder prereg-password-submit-holder">
              {isSuccess ? (
                <button type="button" className="prereg-next prereg-step3-submit" onClick={handleGoToSignIn}>INICIAR SESIÓN</button>
              ) : (
                <button type="button" className="prereg-next prereg-step3-submit" onClick={handleUpdate} disabled={isSubmitting}>{isSubmitting ? 'Actualizando...' : 'ACTUALIZAR'}</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
